import axios from 'axios';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

import { Credential } from '@/models/credential';
import { Company, Session, UserSession } from '@/models/session';
import { SessionAdmin } from '@/models/session-admin';
import config from '@/utils/config';

@Module({
  name: 'sessionStore',
  namespaced: true,
})
export default class SessionStore<T extends Session> extends VuexModule {
  _session: T = new Session() as T;

  get session(): T {
    return this._session;
  }

  @Action({ commit: 'select', rawError: true })
  async login(credentials: Credential): Promise<Session> {
    const { email, password } = credentials;
    const response = await axios.post(`${config.getAPIAddress()}/user/login`, {
      email,
      password,
    });
    if (response?.data) {
      const result = SessionAdmin.fromJson({
        ...response.data,
        user: {
          ...(response.data?.user || {}),
          authenticated: true,
        },
      });
      return result;
    }
    return {} as Session;
  }

  @Mutation
  select(session: T): void {
    this._session = session;
  }

  @Mutation
  setUser(user: UserSession) {
    this._session.user = user;
  }

  @Mutation
  removeUser() {
    this._session.user = { authenticated: false } as UserSession;
  }

  @Mutation
  setCompanies(companies: Array<Company>) {
    this._session.companies = companies;
  }

  @Mutation
  removeCompanies() {
    this._session.companies = [];
  }

  @Mutation
  setClient(client: Company) {
    this._session.client = client;
  }

  @Mutation
  removeClient() {
    this._session.client = null;
  }

  @Mutation
  setCompany(company: Company) {
    this._session.company = company;
  }

  @Mutation
  removeCompany() {
    this._session.company = null;
  }

  @Mutation
  clear() {
    this._session = new Session() as T;
  }
}
